import React, { useState } from 'react';
import { PinturaEditorOverlay } from '@pqina/react-pintura';
import '@pqina/pintura/pintura.css';
import {
  locale_en_gb,
  createDefaultImageReader,
  createDefaultImageWriter,
  setPlugins,
  plugin_crop,
  plugin_crop_locale_en_gb,
  plugin_filter,
  plugin_filter_locale_en_gb,
  plugin_filter_defaults,
  createDefaultImageOrienter,
  createDefaultImageScrambler,
} from '@pqina/pintura';

setPlugins(plugin_crop, plugin_filter);

// Custom filter function
const customApiFilter = async (imageData) => {
  const canvas = document.createElement('canvas');
  canvas.width = imageData.width;
  canvas.height = imageData.height;
  const ctx = canvas.getContext('2d');
  ctx.putImageData(imageData, 0, 0);

  const blob = await new Promise((resolve) =>
    canvas.toBlob(resolve, 'image/jpeg')
  );

  const formData = new FormData();
  formData.append('image', blob);

  const response = await fetch('https://your-api.com/filter', {
    method: 'POST',
    body: formData,
  });

  const processedBlob = await response.blob();
  const img = await createImageBitmap(processedBlob);
  const resultCanvas = document.createElement('canvas');
  resultCanvas.width = img.width;
  resultCanvas.height = img.height;
  const resultCtx = resultCanvas.getContext('2d');
  resultCtx.drawImage(img, 0, 0);

  return resultCtx.getImageData(0, 0, resultCanvas.width, resultCanvas.height);
};

const editorDefaults = {
  imageReader: createDefaultImageReader(),
  imageWriter: createDefaultImageWriter(),
  imageOrienter: createDefaultImageOrienter(),
  imageScrambler: createDefaultImageScrambler(),

  // ⭐ ВАЖЛИВО: Додати custom filters ТУТ
  filterOptions: {
    // Взяти дефолтні фільтри
    ...plugin_filter_defaults.filterOptions,

    // Додати свої custom filters
    ai_filter: (imageData) => customApiFilter(imageData),
    remove_bg: async (imageData) => {
      const canvas = document.createElement('canvas');
      canvas.width = imageData.width;
      canvas.height = imageData.height;
      const ctx = canvas.getContext('2d');
      ctx.putImageData(imageData, 0, 0);

      const blob = await new Promise((resolve) =>
        canvas.toBlob(resolve, 'image/png')
      );

      const formData = new FormData();
      formData.append('image_file', blob);

      const response = await fetch('https://api.remove.bg/v1.0/removebg', {
        method: 'POST',
        headers: {
          'X-Api-Key': 'YOUR_API_KEY',
        },
        body: formData,
      });

      const resultBlob = await response.blob();
      const img = await createImageBitmap(resultBlob);

      const resultCanvas = document.createElement('canvas');
      resultCanvas.width = img.width;
      resultCanvas.height = img.height;
      const resultCtx = resultCanvas.getContext('2d');
      resultCtx.drawImage(img, 0, 0);

      return resultCtx.getImageData(
        0,
        0,
        resultCanvas.width,
        resultCanvas.height
      );
    },
  },

  locale: {
    ...locale_en_gb,
    ...plugin_crop_locale_en_gb,
    ...plugin_filter_locale_en_gb,

    // ⭐ Додати назви для кнопок
    labelButtonFilterAiFilter: 'AI Enhance',
    labelButtonFilterRemoveBg: 'Remove BG',
  },
};

export default function ExampleOverlay() {
  const [visible, setVisible] = useState(false);
  const [result, setResult] = useState({
    imagePreview: './image.jpeg',
    imageState: undefined,
  });
  const [loading, setLoading] = useState(false);

  return (
    <div className="App">
      <h2>Overlay with Custom API Filters111</h2>

      <p>
        {!visible && (
          <button onClick={() => setVisible(true)}>Edit image</button>
        )}
        {visible && (
          <button onClick={() => setVisible(false)}>Close editor</button>
        )}
      </p>

      {loading && <p>Processing with AI...</p>}

      {!visible && (
        <p>
          <img width="512" height="256" src={result.imagePreview} alt="" />
        </p>
      )}
      {visible && (
        <div style={{ width: '512px', height: '256px' }}>
          <PinturaEditorOverlay
            src={'./image.jpeg'}
            {...editorDefaults}
            imageState={result.imageState}
            onLoad={(res) => console.log('load image', res)}
            onProcess={({ dest, imageState }) => {
              setResult({
                imagePreview: URL.createObjectURL(dest),
                imageState: imageState,
              });
              setVisible(false);
              setLoading(false);
            }}
            onLoaderror={(error) => {
              console.error('Load error:', error);
              setLoading(false);
            }}
          />
        </div>
      )}
    </div>
  );
}
